import { AxiosResponse} from "axios";
import Api from "../api";

export default (action : string,memberId : number, page:number, perPage:number): Promise<AxiosResponse> => {
    const path = `followings/${(action == 'followers') ? 'getFollowers' : 'getFollowings'}`
    return Api.getInstance().request.get(`${path}?page=${page}&per-page=${perPage}&member_id=${memberId}`, path)
}